<template>
  <div>
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="mb-0 ml-2" style="font-size: 16px">Billing</h4>
      </div>
      <div class="d-flex flex-column border-top p-2 mt-2">
        <div
          class="d-flex justify-content-between mt-2"
          style="font-size: 14px"
        >
          <strong
            >Unpaid invoices ({{ billingSummary.totalUnpaidInvoices }})</strong
          >
          <span>{{ toCurrencyValue(billingSummary.unpaidInvoicesSum) }}</span>
        </div>
      </div>
      <div class="d-flex flex-column p-2 mt-2">
        <div
          class="d-flex justify-content-between mt-2"
          style="font-size: 14px"
        >
          <strong
            >Uninvoiced ({{ billingSummary.totalUninvoicedEncounters }})</strong
          >
          <span>{{
            toCurrencyValue(billingSummary.uninvoicedEncountersSum)
          }}</span>
        </div>
      </div>
      <div class="w-100">
        <b-button
          class="w-100"
          :disabled="billingSummary.totalUnpaidInvoices === 0"
          @click="addPayment"
          variant="success"
          >Add Payment</b-button
        >
      </div>
      <payment-add-edit-modal
        v-if="addPaymentModal.show"
        v-model="addPaymentModal.show"
        :transactionType="'Payment'"
        :formTitle="
          `Add payment for: ${this.formatClient(
            this.patient.firstName,
            this.patient.middleName,
            this.patient.preferredName,
            this.patient.lastName
          )}`
        "
        :patientId="this.patient.id"
        @onHidden="
          () => {
            addPaymentModal.show = false;
            fetchBillingSummary();
          }
        "
        @success="
          () => {
            addPaymentModal.show = false;
            fetchBillingSummary();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import billingServer from "../../server/billing";
import PaymentAddEditModal from "../billing/billing_transactions/PaymentAddEditModal.vue";
export default {
  name: "EocViewSummaryBilling",
  props: ["patient", "showing", "refresh"],
  components: { PaymentAddEditModal },
  data() {
    return {
      billingSummary: {},
      addPaymentModal: {
        show: false
      }
    };
  },
  mounted() {
    this.fetchBillingSummary();
  },
  methods: {
    async fetchBillingSummary() {
      this.billingSummary = await billingServer.getPatientBillingSummary(
        this.patient.id
      );
    },
    addPayment() {
      this.addPaymentModal.show = true;
    }
  },
  watch: {
    showing(newValue) {
      if (newValue) {
        this.fetchBillingSummary();
      }
    },
    refresh() {
      this.fetchBillingSummary();
    }
  }
};
</script>

<style></style>
